import React from 'react';

/**
 * Payment method picker for the checkout. Renders whatever `listCheckoutPaymentOptions` returned
 * for the region; layout depends only on adapter fields, never on which provider it is.
 */
export function PaymentOptions({ options, selectedId, onSelect, disabled = false }) {
  if (!options || !options.length) {
    return (
      <p role="alert" className="text-white-50" style={{ fontSize: 14 }}>
        Nenhuma forma de pagamento disponível para esta região.
      </p>
    );
  }
  return (
    <fieldset className="mb-3" disabled={disabled}>
      <legend className="visually-hidden">Forma de pagamento</legend>
      {options.map((option) => (
        <div className="form-check" key={option.id}>
          <input
            className="form-check-input"
            type="radio"
            name="payment-provider"
            id={`payment-${option.id}`}
            value={option.id}
            checked={selectedId === option.id}
            onChange={() => onSelect(option.id)}
          />
          <label className="form-check-label text-white" htmlFor={`payment-${option.id}`}>
            {option.label}
            <span className="d-block text-white-50" style={{ fontSize: 13 }}>
              {option.description}
              {option.capabilities.includes('async_confirmation') &&
                ' A confirmação pode levar alguns minutos; o pedido fica aguardando pagamento até lá.'}
              {option.testOnly && ' Ambiente de teste.'}
            </span>
          </label>
        </div>
      ))}
    </fieldset>
  );
}

export default PaymentOptions;
